import { useQuery } from '@tanstack/react-query';

import { useAppState } from '../../AppStateProvider';
import type { Crm, CrmStatus } from '../../domain/crm';

import { crmApi } from './api';

export const useCrmStatusQuery = (crm: Crm) => {
  const { isOpen } = useAppState();

  return useQuery<CrmStatus>({
    queryKey: ['status', crm],
    queryFn: () => crmApi.fetchCrmStatus(crm),
    enabled: isOpen,
  });
};
